import apiClient from '@/plugins/apiClient'
let basePath = "hostess/contact-forms";
import qs from 'qs';

export default {
     namespaced: true,
     state:{
          list: [],
          exportFile: null,
          errors: null,
          message: null,
          meta: {
               current_page: 1,
               total: 0,
               per_page: 12
          },
          filters: {
               wheres : []
          }
     },
     getters:{
          list: state => state.list,
          exportFile: state => state.exportFile,
          message: state => state.message,
          errors: state => state.errors,
          meta: state => state.meta,
          filters: state => state.filters,
     },
     mutations:{
        error(state, err) {
            console.log('mutation error',err);
            state.message = err.response.data.message
            state.errors = err.response.data.errors
        },
        setList(state, resp) {
            console.log('mutation setList',resp);
            state.list = resp.data;
        },
        setMeta(state, resp){
          console.log('mutation setMeta',resp.meta);
          state.meta = resp.meta
        },
        setExport(state, resp){
          console.log('mutation export',resp.data);
          state.exportFile = resp.data
        },
     },
     actions:{
          getList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    console.log('GET LIST REGISTRATIOND:'+data)
                    var params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'/'+data.id+'/registrations?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getExport({commit, state}, data){
               return new Promise((resolve, reject) => {
                    console.log('GET LIST REGISTRATIOND:'+data)
                    apiClient.get(basePath+'/'+data.id+'/registrations/export').then(resp => {
                         commit('setExport', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          updateSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    console.log('Udate Single Registration:', data)
                    apiClient.patch(basePath+'/'+data.contact_form_id+'/registrations/'+data.id+'/update', data).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          deleteSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    console.log('DELEDETE Single registration:', data)
                    apiClient.delete(basePath+'/'+data.contact_form_id+'/registrations/'+data.id+'/delete',).then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          setAsSingle({state}, data){
               state.single = data;
          },
          removeErrors({state}){
               state.errors = null;
               state.message = null;
          },
          setMeta({commit}, data){
               console.log('action meta',data);
               commit('setMeta',{meta:data});
               // commit('success', true);
          }
     },
}